export default __webpack_public_path__ + "static/media/chart-take-away.dd9ce209.svg";